const SUBMITTED_KEY_PREFIX = 'leadFormSubmitted_';
const AUTO_OPENED_KEY_PREFIX = 'leadFormAutoOpened_';
const DISMISSED_KEY_PREFIX = 'leadFormDismissed_';
const DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function safeGet(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(storage: Storage, key: string, value: string): void {
  try {
    storage.setItem(key, value);
  } catch {
    // Private mode / storage full — ignore
  }
}

/** Persists across visits so auto-open does not re-prompt after a successful submit. */
export function hasSubmittedLeadForm(profileId: string): boolean {
  if (typeof window === 'undefined') return false;
  return (
    safeGet(localStorage, `${SUBMITTED_KEY_PREFIX}${profileId}`) === 'true'
  );
}

export function markLeadFormSubmitted(profileId: string): void {
  if (typeof window === 'undefined') return;
  safeSet(localStorage, `${SUBMITTED_KEY_PREFIX}${profileId}`, 'true');
}

/** Session-only: avoid auto-opening again in the same tab if the visitor dismissed it. */
export function hasAutoOpenedLeadForm(profileId: string): boolean {
  if (typeof window === 'undefined') return false;
  return (
    safeGet(sessionStorage, `${AUTO_OPENED_KEY_PREFIX}${profileId}`) === 'true'
  );
}

export function markLeadFormAutoOpened(profileId: string): void {
  if (typeof window === 'undefined') return;
  safeSet(sessionStorage, `${AUTO_OPENED_KEY_PREFIX}${profileId}`, 'true');
}

/** 7-day dismiss across tabs after the visitor closes the auto-open form. */
export function hasDismissedLeadFormRecently(profileId: string): boolean {
  if (typeof window === 'undefined') return false;
  const raw = safeGet(localStorage, `${DISMISSED_KEY_PREFIX}${profileId}`);
  if (!raw) return false;
  const at = Number(raw);
  if (!Number.isFinite(at)) return false;
  return Date.now() - at < DISMISS_TTL_MS;
}

export function markLeadFormDismissed(profileId: string): void {
  if (typeof window === 'undefined') return;
  safeSet(
    localStorage,
    `${DISMISSED_KEY_PREFIX}${profileId}`,
    String(Date.now()),
  );
}
